import "./AlertComponent.scss";
import {IComponentOptions} from "angular";
import {TradingAlert} from "../../models/alert/TradingAlert";
import {TradingAlertViewStore} from "../../view-store/TradingAlertViewStore";
import {IvSidebarService} from "../../../components/ui/iv-sidebar/service/IvSidebarService";
import {FeatureNames} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {TradingAlertViewDialogService} from "../../services/TradingAlertViewDialogService";

export const Alert = "tfTradingAlert";

export function alert(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/alert/AlertComponent.html`,
        controllerAs: "ctrl",
        controller: AlertComponentController,
        bindings: {
            alert: "<",
            viewStore: "<"
        }
    };
}

export class AlertComponentController {

    public readonly alert: TradingAlert;
    public readonly viewStore: TradingAlertViewStore;

    /** @ngInject */
    public constructor(private readonly ivSidebarService: IvSidebarService,
                       private readonly confirmationService: ConfirmationService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly tradingAlertViewDialogService: TradingAlertViewDialogService) {
    }

    public closeAlert() {
        const alertId = this.alert.id;
        if (this.alert.matched) {
            this.acknowledgedAlert(alertId);
        } else {
            this.cancelAlert(alertId);
        }
    }

    public edit() {
        this.viewStore.editAlert(this.alert);
    }

    public view() {
        this.tradingAlertViewDialogService.open(this.alert);
    }

    private async cancelAlert(id: number) {
        const confirm = await this.confirmationService.confirm("deleteSecurityAlert");
        if (confirm) {
            this.viewStore.cancelAlert(id);
        }
    }

    private async acknowledgedAlert(id: number) {
        const confirm = await this.confirmationService.confirm("deleteSecurityAlert");
        if (confirm) {
            this.viewStore.acknowledgeAlert(id);
        }
    }
}
